var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMastercard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 15,
    viewBox: "0 0 26 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8458 13.2084C11.5204 14.3256 9.80107 15 7.92236 15C3.73034 15 0.332031 11.6421 0.332031 7.5C0.332031 3.35786 3.73034 0 7.92236 0C9.80107 0 11.5204 0.674435 12.8458 1.79164C14.1712 0.674435 15.8905 0 17.7692 0C21.9613 0 25.3596 3.35786 25.3596 7.5C25.3596 11.6421 21.9613 15 17.7692 15C15.8905 15 14.1712 14.3256 12.8458 13.2084Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8447 13.2088C14.4771 11.8332 15.5121 9.78602 15.5121 7.5C15.5121 5.21398 14.4771 3.16684 12.8447 1.7912C14.1701 0.674257 15.8892 0 17.7676 0C21.9597 0 25.358 3.35786 25.358 7.5C25.358 11.6421 21.9597 15 17.7676 15C15.8892 15 14.1701 14.3257 12.8447 13.2088Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8466 13.2083C14.4786 11.8327 15.5134 9.78572 15.5134 7.49995C15.5134 5.21417 14.4786 3.16723 12.8466 1.79159C11.2145 3.16723 10.1797 5.21417 10.1797 7.49995C10.1797 9.78572 11.2145 11.8327 12.8466 13.2083Z",
    fill: "#FF5E00"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMastercard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mastercard.95d81d0e20da170a161743325de919da.svg";